import { useQuery } from '@tanstack/react-query';
import { Col, Row } from 'antd';
import { HighlightedDashboardSubtitle, SectionTitle } from '../components/dashboard/styles';
import { PerksList } from '../containers';
import perksService from '../services/perks.service';

export const PerksDashboard: React.FC = () => {
	const { data: perksData, isLoading: perksDataLoading } = useQuery({
		queryKey: ['perks'],
		queryFn: () => perksService.getPerks()
	});

	return (
		<div className={`dashboard`} style={{ width: '95%' }} id="dashboard">
			<Row gutter={0} className="mb-3">
				<Col xs={24} className="text-start  d-flex flex-column mb-3 mb-md-0">
					<SectionTitle>Perks</SectionTitle>
					<Col xs={24} md={8} className="mb-3 mb-md-0">
						You have{' '}
						<HighlightedDashboardSubtitle>{perksData?.length ?? 0} perks</HighlightedDashboardSubtitle>
					</Col>
				</Col>
			</Row>

			<PerksList perksData={perksData} perksDataLoading={perksDataLoading} />
		</div>
	);
};
